import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';

export default function VistageChairs({pageContent}:any) {
  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
      <main className="row vistage-row">
        <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
        <section className="col-12 execution-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 vs-execution-text subtitle-font" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].execution_analysis_text)}}>
                {/* */}
              </div>
              <div className="col-12 col-sm-6 vs-content regular-font">
                <div className="col-12 vs-execution-img">
                  <img src={urlFor(pageContent[0].execution_analysis_image).width(1000).url()} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 vs-contact-title title-font">
                {pageContent[0].vistage_chairs_contact_title}
              </div>
              <div className="col-12 vs-contact-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].contact_text)}}>
                {/* */}
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 community-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 vs-content regular-font">
                <div className="col-12 community-img">
                  <img src={urlFor(pageContent[0].community_image).width(1000).url()} />
                </div>
              </div>
              <div className="col-12 col-sm-6 community-text subtitle-font" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].community_text)}}>
                {/* */}
              </div>
            </div>
            <div className="row">
              <div className="col-12 vs-contact-callout">
                <div className="row">
                  <div className="col-12 callout-color-bg subtitle-font text-center" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].contact_information_text)}}>
                    {/* */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 vs-section">
          <div className="container">
            <div className="row  vs-section-content">
              <div className="col-12 vs-title title-font text-center" >
                {pageContent[0].vistage_chairs_title}
              </div>
              <div className="col-12 vs-title title-font text-center" >
                {pageContent[0].vistage_chairs_subtitle}
              </div>
              <div className="col-12">
                <div className="row">
                  <div className="col-12 col-sm-6 vs-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].vistage_chairs_text_left)}}>
                    {/* */}
                  </div>
                  <div className="col-12 col-sm-6 vs-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].vistage_chairs_text_right)}}>
                    {/* */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 pinnacle-chair">
          <div className="container">
            <div className="row">
              <div className="col-12 pinnacle-title title-font text-center" >
                {pageContent[0].pinnacle_title}
              </div>
              <div className="col-12 col-sm-4 pinnacle-content regular-font">
                <div className="col-12 pinnacle-img">
                  <img src={urlFor(pageContent[0].pinnacle_image).width(700).url()} />
                </div>
              </div>
              <div className="col-12 col-sm-8 pinnacle-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].pinnacle_text)}}>
                {/* */}
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 eos">
          <div className="container">
            <div className="row">
              <div className="col-12 eos-title title-font text-center" >
                {pageContent[0].eos_title}
              </div>
              <div className="col-12 eos-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].eos_text)}}>
                {/* */}
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 consultant">
          <div className="container">
            <div className="row">
              <div className="col-12 consultant-title title-font text-center" >
                {pageContent[0].consultant_title}
              </div>
              <div className="col-12 col-sm-8 consultant-list" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].consultant_text)}}>
                {/* */}
              </div>
              <div className="col-12 col-sm-4 consultant-content regular-font">
                <div className="col-12 consultant-img">
                  <img src={urlFor(pageContent[0].consultant_image).width(700).url()} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="col-12 contact">
          <div className="container">
            <div className="row">
              <div className="col-12 vs-contact-callout">
                <div className="row">
                  <div className="col-12 callout-color-bg subtitle-font text-center" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].contact_information_text)}}>
                    {/* */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "vistageChairsPage"]`);
  return {
    props: {
      pageContent: pageContent
    }
  }
}
